// extracted by mini-css-extract-plugin
module.exports = {"GoHome":"GoHome_GoHome__Obr64"};